import { Component, OnInit } from "@angular/core";
import { CommonService } from "../services/common.service";

@Component({
	selector: "app-thanks",
	templateUrl: "./thanks.component.html",
	styleUrls: ["./thanks.component.scss"],
})
export class ThanksComponent implements OnInit {
	lang;
	constructor(private common: CommonService) {
		this.lang = localStorage.getItem("idioma");
	}

	ngOnInit(): void {}
	redirect() {
    this.common.setClickTest();
		if (this.lang == "esp") {
			window.open("https://go-fit.es/tcv/test/web/abonado?origen=web");
		} else if (this.lang == "por") {
			window.open("https://go-fit.es/tcv/test/web/abonado/pt?origen=web");
		}
	}
}
